import { Toolbar, Tooltip } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { UserListDataProvider } from '../../data/DataProviders/UserListProvider';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { ManageUserList } from './ManageUserList';
import userStyles from './UserStyle';
import { pushAppRoute } from '../../data/domain/route-manager';
import { GenericToolbar } from '../../components/GenericToolbar';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { ContentContainer } from '../../components/ContentContainer';
import { RecordDataIndicators } from '../../components/RecordDataIndicators';
import { getAppRouteCacheName, AppRoutes } from '../../routes';
import { useAppRoute } from '../../hooks/app-route-hooks';

export const ManageUser: React.FC = () => {
    const { t } = useLanguageLocale();
    const selectedOrganization = useSelectedOrganizationData();
    const classes = userStyles();
    const history = useHistory();
    const currentAppRoute = useAppRoute('ManageUser');

    const NavigateToAddUser = (): void => {
        pushAppRoute(history, { type: 'AddUser', orgId: currentAppRoute.orgId });
    };

    if (!isRecordFound(selectedOrganization)) {
        return (
            <>
                <ContentContainer>
                    <RecordDataIndicators
                        recordData={selectedOrganization}
                        errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                        notFoundIcon="Business"
                        notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
                    />
                </ContentContainer>
            </>
        );
    }
    return (
        <>
            <DataProviderCache for={getAppRouteCacheName(AppRoutes.ManageUser)}>
                <UserListDataProvider siteId={selectedOrganization.value.id}>
                    <GenericToolbar title={t('SETTINGS.TITLE')} subtitle={t('SETTINGS.SUBTITLE')} />

                    <ContentContainer>
                        <Toolbar component="div" data-testid="search-div" className={classes.serachDiv}>
                            <div className={classes.addUserIconDiv}>
                                <Tooltip arrow title="Add User" >
                                    <PersonAddIcon
                                    data-testid="add-icon"
                                    className={classes.addIcon}
                                    onClick={NavigateToAddUser}
                                ></PersonAddIcon>
                                </Tooltip>
                            </div>
                        </Toolbar>
                        <ManageUserList />
                    </ContentContainer>
                </UserListDataProvider>
            </DataProviderCache>
        </>
    );
};
